/*
 * utm_* kept through /start (design Req 7). Read once from the landing URL and
 * held for the whole flow, with a sessionStorage copy so a reload mid-flow
 * keeps them; rails stores them with the signup ticket (and the 4A resume
 * link carries them back in its own query). Values only: never PII.
 */
const KEYS = ["utm_source", "utm_medium", "utm_campaign", "utm_term", "utm_content"];
const STORE = "mb.freeStart.utm";
const MAX = 200;

const read = () => {
  try {
    const raw = window.sessionStorage.getItem(STORE);
    return raw ? JSON.parse(raw) : null;
  } catch (_e) {
    return null;
  }
};

const write = (utm) => {
  try {
    window.sessionStorage.setItem(STORE, JSON.stringify(utm));
  } catch (_e) {
    // private mode / blocked storage: the in-memory copy still carries them
  }
};

export const fromSearch = (search) => {
  const params = new URLSearchParams(search || "");
  const utm = {};
  KEYS.forEach((k) => {
    const v = params.get(k);
    if (v) utm[k] = v.slice(0, MAX);
  });
  return utm;
};

// The URL's utm_* win when it has any; otherwise the stored set from earlier
// in this tab's flow.
export const captureUtm = (search) => {
  const fromUrl = fromSearch(search);
  if (Object.keys(fromUrl).length) {
    write(fromUrl);
    return fromUrl;
  }
  return read() || {};
};

// Once the account exists the set has been stored by rails; drop the copy.
export const clearUtm = () => {
  try {
    window.sessionStorage.removeItem(STORE);
  } catch (_e) {
    // nothing stored
  }
};
